import { useState, useEffect, useCallback } from "react";
import { copyToClipboard } from "@/lib/clipboard";
import { toast } from "sonner";

/**
 * Hook for managing container data state and export operations
 * Handles response JSON, copy, and export functionality
 */
export const useContainerData = <T = any>(data?: T) => {
  const [responseJSON, setResponseJSON] = useState<string>("");

  useEffect(() => {
    if (data) {
      setResponseJSON(JSON.stringify(data, null, 2));
    }
  }, [data]);

  const handleCopyCode = useCallback(() => {
    copyToClipboard(responseJSON || "{}");
    toast.success("Copied to clipboard");
  }, [responseJSON]);

  return {
    responseJSON,
    setResponseJSON,
    handleCopyCode,
  };
};
